import request from '@/router/axios';

export const add = (row) => {
  return request({
    url: '/api/produce/device-alarm-records/insert',
    method: 'post',
    data: row
  })
}
export const update = (row) => {
  return request({
    url: '/api/produce/device-alarm-records/update',
    method: 'post',
    data: row
  })
}
export const getDetail = (id) => {
  return request({
    url: '/api/produce/device-alarm-records/select/id',
    method: 'get',
    params: {
      id
    }
  })
}
export const getList = (params) => {
  return request({
    url: '/api/produce/device-alarm-records/select/page',
    method: 'post',
    params
  })
}
export const remove = (ids) => {
  return request({
    url: '/api/produce/device-alarm-records/delete/ids',
    method: 'post',
    params: {
      ids
    }
  })
}

